import { render, staticRenderFns } from "./huurtegoed.vue?vue&type=template&id=241fc81c"
import script from "./huurtegoed.vue?vue&type=script&lang=js"
export * from "./huurtegoed.vue?vue&type=script&lang=js"
import style0 from "./huurtegoed.vue?vue&type=style&index=0&id=241fc81c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports